export const LoginUser = {
  user_id: "1",
  name: "Shams UL Azeem",
  email: "shams@ul.azeem",
  user_avatar: "https://avatars.githubusercontent.com/u/17789400?v=4",
  // companies: ["Company A", "Company B", "Company C"],
};
